export default __webpack_public_path__ + "static/media/orgLogoLoader.96d3c61a.svg";